/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

import Alert from '@material-ui/lab/Alert';

import {
  TextField,
  Button,
  IconButton,
  Grid,
  InputAdornment,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core';

import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import LockIcon from '@material-ui/icons/Lock';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AddIcon from '@material-ui/icons/Add';
import HowToRegIcon from '@material-ui/icons/HowToReg';

import { useMutation } from '@apollo/client';
import { LOGIN_USER, CREATE_USERS_ACCOUNT } from '../../queries';
import { useThemeData } from '../../context/ThemeDataContext';
import {
  loginHashArrayFromStorage,
  saveLoginData,
  saveTokens,
  getRoles,
} from '../../services/auth.service';
import GeneralButton from '../Buttons';
import GeneralText from '../Fonts';
import Snackbar from '@material-ui/core/Snackbar';
import { useAuthData } from '../../context/AuthProvider';
import Loading from '../../screens/loading';
import SnackbarComponent from '../Nav/SnackbarComponent';

function LoginFormComponent(props) {
  const APP_URL = process.env.REACT_APP_SITE_URL;
  const { company_image, border_radius, primary_color_2, font_family_button } =
    useThemeData().themeData.site.theme;
  const { create_account } = useThemeData().modules;
  const { site_id } = useThemeData().themeData.site;

  const location = props.history.location.state;
  const { loadingLogin, setLoadingLogin, SnackbarIsOpen, setSnackbarIsOpen } = useAuthData();

  const [login, setLogin] = useState({
    users: [{ login_name: '', login_password: '' }],
  });
  const [account, setAccount] = useState({
    email: '',
    password: '',
    password_validation: '',
  });
  const [clients] = useState({
    client_id: 2,
    client_secret: 'B4qLlm3bRViBRU6D0DNyxn0V9XtXzeLJV7iUHErt',
  });
  const [Checkboxes, setCheckbox] = useState({
    LoginAccount: true,
    CreateAccount: false,
  });
  const [validation, setValidation] = useState({
    users: [{ login_name: 'notActive', login_password: 'notActive' }],
    validated: 'notActive',
    email: 'notActive',
    password: 'notActive',
    password_validation: 'notActive',
  });
  const [validated, setValidated] = useState(false);
  const [alertStatus, setAlertStatus] = useState({
    success: { open: false, message: '' },
    error: { open: false, message: '' },
    horizontal: 'center',
    vertical: 'top',
  });
  const { vertical, horizontal } = alertStatus;

  const loginhash = useParams().login;
  const { hash } = useParams();

  const addClick = () => {
    setLogin((prevState) => ({
      users: [
        ...prevState.users,
        {
          login_name: '',
          login_password: '',
        },
      ],
    }));
    setValidation((prevState) => ({
      ...prevState,
      users: [
        ...prevState.users,
        {
          login_name: 'notActive',
          login_password: 'notActive',
        },
      ],
    }));
  };

  const setPasswordForgotten = () => {
    let location = {
      pathname: '/forgotten-password',
    };
    props.history.push(location);
  };

  const handleChange = (e, i) => {
    const { name, value, type } = e.target;
    if (type !== 'radio' && type !== 'checkbox') {
      let users = [...login.users];
      users[i] = { ...users[i], [name]: value };
      setLogin({ users: users });
      if (name === 'login_name' || name === 'login_password') {
        let val = [...validation.users];
        let newName = name === 'login_password' ? 'login_name' : 'login_password';
        let newValue = name === 'login_password' ? val[i].login_name : val[i].login_password;
        if (value === '') {
          val[i] = { ...users[i], [name]: false, [newName]: newValue };
          setValidation((prevState) => ({ ...prevState, users: val }));
        } else {
          val[i] = { ...users[i], [name]: true, [newName]: newValue };
          setValidation((prevState) => ({ ...prevState, users: val }));
        }
      }
      if (name === 'email' || name === 'password' || name === 'password_validation') {
        if (value === '') {
          setValidation((prevState) => ({ ...prevState, [name]: false }));
        } else {
          setValidation((prevState) => ({ ...prevState, [name]: 'active' })); // activates email/password validation checks
        }
        setAccount((prevState) => ({ ...prevState, [name]: value }));
      }
    } else {
      if (name === 'LoginAccount') {
        setCheckbox({ LoginAccount: true, CreateAccount: false });
      }
      if (name === 'CreateAccount') {
        setCheckbox({ LoginAccount: false, CreateAccount: true });
      }
    }
  };

  useEffect(() => {
    //check if email has correct format
    const emailRegex = new RegExp(
      '[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)+(?:\\.[^\\.\\s@]+)*',
    );
    if (validation.email === 'active') {
      if (!emailRegex.test(account.email)) {
        setValidation((prevState) => ({ ...prevState, email: false }));
      } else {
        setValidation((prevState) => ({ ...prevState, email: true }));
      }
    }
  }, [validation.email, account.email]);

  useEffect(() => {
    //check if password is at least 8 characters, with a-z in capitals and normal, with numbers and symbols
    const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    if (validation.password === 'active') {
      if (!strongRegex.test(account.password)) {
        setValidation((prevState) => ({ ...prevState, password: false }));
      } else {
        setValidation((prevState) => ({ ...prevState, password: true }));
      }
    }
  }, [validation.password, account.password]);

  useEffect(() => {
    //check if validation password matches password
    if (validation.password_validation === 'active') {
      if (
        account.password_validation.length < 8 ||
        account.password_validation !== account.password
      ) {
        setValidation((prevState) => ({
          ...prevState,
          password_validation: false,
        }));
      } else {
        setValidation((prevState) => ({
          ...prevState,
          password_validation: true,
        }));
      }
    }
  }, [validation.password_validation, account.password_validation, account.password]);

  const removeClick = (i) => {
    let users = [...login.users];
    let val = [...validation.users];
    users.splice(i, 1);
    val.splice(i, 1);
    setLogin({ users: users });
    setValidation((prevState) => ({ ...prevState, users: val }));
  };

  const closeSnackbar = () => {
    setSnackbarIsOpen(false);
  };

  const logErrors = () => {
    setSnackbarIsOpen(true);
    setLoadingLogin(false);
  };

  function setLocation(role) {
    if (typeof props.location.state !== 'undefined') {
      props.history.push({
        pathname: `/ photos / ${props.location.state.folder_id} `,
        state: { loggedIn: true, folder_id: props.location.state.folder_id },
      });
    } else {
      if (role === 'school') {
        window.location = '/dasboard/';
      } else {
        window.location = '/';
      }
    }
  }

  function createArrayOfData(data) {
    let valuesArrObj = [];
    data.forEach((val) => {
      valuesArrObj.push({
        [val]: val,
      });
    });

    return data;
  }

  function setLoginData(login) {
    let logins = login.login_name;
    let login_passwords = login.login_password;

    if (!logins.length > 0) {
      logErrors();
      return;
    }

    saveTokens(login.access_token);

    if (login.user !== null) {
      let login_email = login.user.email;
      if (login_email.includes('@') === true) {
        localStorage.setItem('login_email', login_email);
      }
    }

    saveLoginData(createArrayOfData(logins), createArrayOfData(login_passwords));
    setLocation(getRoles());
  }

  function getLoginData(e) {
    return new Promise((resolve, reject) => {
      resolve(e.login);
    }).then((data) => {
      console.log(data);
      return setLoginData(data);
    });
  }

  const [loginUser, { loading: loadingCreateUser }] = useMutation(LOGIN_USER, {
    onCompleted: (e) => {
      return getLoginData(e);
    },
    onError: (error) => {
      return logErrors();
    },
  });

  function deduplicateLoginNames(queryInput) {
    // Destructure the queryInput to extract fields
    const { login_name, ...rest } = queryInput;

    // Split the login_name by comma, remove duplicates, and join back with comma
    const uniqueLoginNames = Array.from(new Set(login_name.split(','))).join(',');

    // Return a new object with the deduplicated login_name and other properties
    return {
      ...rest,
      login_name: uniqueLoginNames
    };
  }

  const fireLoginMutation = useCallback(
    (queryInput) => {
      return new Promise((resolve, reject) => {
        setLoadingLogin(true);
        loginUser({
          variables: queryInput,
        }).then((data) => {
          if (data.data === undefined) {
            reject(data.errors);
          } else {
            resolve(data.data);
          }
        });
      })
        .then((data) => {
          return data;
        })
        .catch((error) => {
          return error;
        });
    },
    [setLoadingLogin, loginUser],
  );

  useEffect(() => {
    /* Log in using QR code if loginhash and hash are both present */
    if (loginhash && hash) {
      const login_username = loginHashArrayFromStorage(loginhash);
      let queryInput;

      if (props.match.params.v2) {
        // Construct query input for v2
        queryInput = {
          v2: props.match.params.v2,
          login_name: login_username,
          login_password: hash.toString(),
          client_id: clients.client_id,
          client_secret: clients.client_secret,
          site_id: site_id,
        };
      } else {
        // Construct query input for non-v2
        if (props.match.params.v2 !== undefined) {
          queryInput = {
            login_name: loginhash.toString(),
            login_password: 'v2',
            client_id: clients.client_id,
            client_secret: clients.client_secret,
            site_id: site_id,
          };
        } else {
          queryInput = {
            login_name: loginhash.toString(),
            login_password: hash.toString(),
            client_id: clients.client_id,
            client_secret: clients.client_secret,
            site_id: site_id,
          };
        }
      }

      console.log(deduplicateLoginNames(queryInput));
      // Fire the login mutation with the constructed query input
     return fireLoginMutation(deduplicateLoginNames(queryInput));
    } else {
      localStorage.removeItem('jwt');
      localStorage.removeItem('login_name');
      localStorage.removeItem('login_password');
      localStorage.removeItem('login_hash');
      localStorage.removeItem('shippingMethod');
      localStorage.removeItem('session_id');
      localStorage.removeItem('photographer_id');
    }
  }, [
    loginhash,
    props.match.params,
    hash,
    site_id,
    clients.client_secret,
    clients.client_id,
    fireLoginMutation,
  ]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertStatus((prevState) => ({
      ...prevState,
      success: { open: false, message: '' },
      error: { open: false, message: '' },
    }));
  };

  const [registerAccount, { loading: loadingRegisterAccount, error: errorRegisterAccount }] =
    useMutation(CREATE_USERS_ACCOUNT, {
      onCompleted: (event) => {
        localStorage.setItem('login_email', event.registerAccount.email);
        const queryInput = {
          login_name: event.registerAccount.email,
          login_password: event.registerAccount.login_password,
          client_id: clients.client_id,
          client_secret: clients.client_secret,
          site_id: site_id,
        };
        return fireLoginMutation(queryInput);
      },
      onError: (error) => {
        setAlertStatus((prevState) => ({
          ...prevState,
          error: { open: true, message: error.message },
        }));
      },
    });

  function checkFields() {
    const users =
      validation.users.find(
        (f) => f.login_name === 'notActive' || f.login_password === 'notActive',
      ) === undefined; // filled in = true || not filled = false

    //  const acceptTerms = validation.acceptTerms === true; // filled in = true || not filled = false
    const fieldsValue = (users === false) === false;

    setValidated(fieldsValue);
    setValidation((prevState) => ({
      ...prevState,
      validated: fieldsValue,
      users: [{ login_name: users, login_password: users }],
    }));
  }

  const LoginMutation = (event) => {
    const form = event.currentTarget;
    const folder_id = location !== undefined ? location.album.folder_id : undefined;
    checkFields();
    if (form.checkValidity() === false || validation.validated === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      let loginNames = [];
      let loginPasswords = [];
      /* eslint-disable array-callback-return */
      login.users.map((item, i) => {
        loginNames.push(login.users[i].login_name);
        if (site_id === '178') {
          loginPasswords.push(login.users[i].login_password.toUpperCase());
        } else {
          loginPasswords.push(login.users[i].login_password);
        }
      });
      const newLoginNames = Array.from(loginNames);
      const newLoginPasswords = Array.from(loginPasswords);

      if (Checkboxes.LoginAccount === true) {
        event.preventDefault();
        const login_names = newLoginNames.toString().replaceAll(' ', '');
        const login_passwords = newLoginPasswords.toString().replaceAll(' ', '');
        const queryInput = {
          login_name: login_names,
          login_password: login_passwords,
          client_id: clients.client_id,
          client_secret: clients.client_secret,
          site_id: site_id,
          album_id: folder_id,
        };
        return fireLoginMutation(queryInput);
      }
      if (Checkboxes.CreateAccount === true) {
        setValidated(true);
        event.preventDefault();
        registerAccount({
          variables: {
            site_id: site_id,
            login_name: loginNames.toString(),
            email: account.email,
            password: account.password,
            roles: 'user',
          },
        });
      }
    }
  };

  if (loadingCreateUser || loadingRegisterAccount || loadingLogin) return <Loading />;

  if (props.match.params.login === undefined) {
    localStorage.removeItem('jwt');
    localStorage.removeItem('login_name');
    localStorage.removeItem('login_password');
    localStorage.removeItem('login_hash');
    localStorage.removeItem('shippingMethod');
    localStorage.removeItem('session_id');
    localStorage.removeItem('photographer_id');
  }

  let login_name_txt = '';
  if (site_id === '178') {
    login_name_txt = props.t('login:Fotocode');
  } else {
    login_name_txt = props.t('login:Your Login Name');
  }

  return (
    <form noValidate validated={validated.toString()} onSubmit={LoginMutation}>
      {SnackbarIsOpen === true && (
        <SnackbarComponent
          closeSnackbar={closeSnackbar}
          message={props.t('login:Login Failed')}
          severity={'error'}
        />
      )}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        name="success"
        open={alertStatus.success.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          {alertStatus.success.message}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        name="error"
        open={alertStatus.error.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {alertStatus.error.message}
        </Alert>
      </Snackbar>

      {validation.validated === false && (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          name="error"
          open={true}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {props.t('register:EmptyField')}
          </Alert>
        </Snackbar>
      )}

      <Grid container direction="row">
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <Grid container direction="row">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {ReactHtmlParser(props.dataPage.page?.tekst)}
            </Grid>
          </Grid>
          <Grid container direction="row">
            <GeneralText style={{ color: primary_color_2 }} variant="h6" gutterBottom={true}>
              {props.t('login:Login')}
            </GeneralText>
          </Grid>

          {login.users.map((item, i) => (
            <Grid container direction="row" key={i} spacing={1}>
              <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                <TextField
                  id="login_name"
                  variant="outlined"
                  type="text"
                  name="login_name"
                  autoComplete="username"
                  value={login.users.login_name}
                  onChange={(e) => handleChange(e, i)}
                  label={login_name_txt}
                  error={validation.users[i].login_name === false}
                  helperText={
                    validation.users[i].login_name === false && props.t('login:LoginName')
                  }
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                <TextField
                  id="login_password"
                  variant="outlined"
                  type="password"
                  name="login_password"
                  autoComplete="current-password"
                  value={login.users.login_password}
                  onChange={(e) => handleChange(e, i)}
                  label={props.t('login:Your Password')}
                  error={validation.users[i].login_password === false}
                  helperText={
                    validation.users[i].login_password === false && props.t('login:Password')
                  }
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={1} md={1} lg={1} xl={1}>
                {i >= 1 ? (
                  <IconButton
                    id="btn"
                    variant="light"
                    onClick={() => removeClick(i)}
                    type="button"
                    name="remove"
                    className="btn btn-light btn-layout btn-layout-small form-control no-bttn-style"
                    style={{
                      textAlign: 'start',
                      borderRadius: `${border_radius} `,
                      color: '#dc3545',
                    }}
                    aria-label="remove loginticket"
                  >
                    <HighlightOffIcon color="inherit" />
                  </IconButton>
                ) : (
                  <div className=" btn-layout btn-layout-small"></div>
                )}
              </Grid>
            </Grid>
          ))}
          {create_account === 'true' && (
            <Grid container direction="row" className="no-margin-bttm forgot-password mb-2">
              <Button
                id="btnLostKey"
                variant="contained"
                onClick={setPasswordForgotten}
                type="button"
                name="lostkey"
                className="hidden-button"
                style={{
                  fontFamily: `${font_family_button}`,
                  textAlign: 'start',
                  borderRadius: `${border_radius}`,
                  backgroundColor: `transparent`,
                  borderColor: `transparent`,
                  boxShadow: `none`,
                  margin: `0.5rem 0rem`,
                }}
                startIcon={<VpnKeyIcon color="inherit" />}
              >
                <p className="display-content underline text-transform-none">
                  {props.t('register:Forgotten Password')}
                </p>
              </Button>
            </Grid>
          )}
          <Grid container direction="row" className="mb-2">
            <Button
              id="btnMultipleLogin"
              variant="contained"
              onClick={addClick}
              type="button"
              name="add"
              style={{
                fontFamily: `${font_family_button}`,
                textAlign: 'start',
                borderRadius: `${border_radius} `,
              }}
              startIcon={<AddIcon color="inherit" />}
            >
              <p className="display-content">{props.t('login:Multiple Logins')}</p>
            </Button>
          </Grid>

          {create_account === 'true' && (
            <Grid container direction="row" className="mb-2">
              <RadioGroup
                aria-label="formGridLoginAccount"
                id="loginOrCreate"
                name="loginOrCreate"
                value={Checkboxes.LoginAccount ? 'LoginAccount' : 'CreateAccount'}
                onChange={(e) => handleChange(e)}
              >
                <FormControlLabel
                  id="LoginAccount"
                  value="0"
                  name="LoginAccount"
                  control={<Radio checked={Checkboxes.LoginAccount} />}
                  label={props.t('login:Account')}
                />
                <FormControlLabel
                  id="CreateAccount"
                  value="1"
                  name="CreateAccount"
                  control={<Radio checked={Checkboxes.CreateAccount} />}
                  label={props.t('login:NewAccount')}
                />
              </RadioGroup>
            </Grid>
          )}

          {create_account === 'true' && Checkboxes.CreateAccount ? (
            <Grid container direction="row" className="mb-2">
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10} className="mb-2">
                <TextField
                  // id="email"
                  name="email"
                  type="email"
                  variant="outlined"
                  value={account.email}
                  onChange={(e) => handleChange(e)}
                  label={props.t('login:CreateEmail')}
                  placeholder={props.t('login:CreateEmail')}
                  required
                  className={
                    validation.email === true
                      ? 'form-control is-valid'
                      : validation.email === false || validation.email === 'active'
                      ? 'form-control is-invalid'
                      : null
                  }
                  autoComplete="username"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AlternateEmailIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={validation.email === false || validation.email === 'active'}
                  helperText={
                    (validation.email === false || validation.email === 'active') &&
                    props.t('register:ErrorEmail')
                  }
                />
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10} className="mb-2">
                <Grid container direction="row">
                  <TextField
                    id="email"
                    variant="outlined"
                    name="password"
                    type="password"
                    margin="normal"
                    className={
                      validation.password === true
                        ? 'form-control is-valid '
                        : validation.password === false || validation.password === 'active'
                        ? 'form-control is-invalid'
                        : null
                    }
                    label={props.t('login:CreatePassword')}
                    placeholder={props.t('login:CreatePassword')}
                    value={account.password}
                    onChange={(e) => handleChange(e)}
                    required
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <VpnKeyIcon />
                        </InputAdornment>
                      ),
                    }}
                    error={validation.password === false || validation.password === 'active'}
                    helperText={
                      (validation.password === false || validation.password === 'active') &&
                      props.t('login:CreatePasswordFeedback')
                    }
                  />
                </Grid>
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10} className="mb-2">
                <Grid container direction="row">
                  <TextField
                    id="email"
                    margin="normal"
                    variant="outlined"
                    name="password_validation"
                    type="password"
                    className={
                      validation.password_validation === true
                        ? 'form-control is-valid'
                        : validation.password_validation === false ||
                          validation.password_validation === 'active'
                        ? 'form-control is-invalid'
                        : null
                    }
                    label={props.t('login:CreatePasswordValidation')}
                    placeholder={props.t('login:CreatePasswordValidation')}
                    value={account.password_validation}
                    onChange={(e) => handleChange(e)}
                    required
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                    }}
                    error={
                      validation.password_validation === false ||
                      validation.password_validation === 'active'
                    }
                    helperText={
                      (validation.password_validation === false ||
                        validation.password_validation === 'active') &&
                      props.t('login:CreatePasswordValidation')
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          ) : null}
          {errorRegisterAccount && (
            <Alert severity="warning">{props.t('register:Duplicate email')}</Alert>
          )}

          {/*<Grid container direction="row">*/}
          {/*  <Grid item xs={12} sm={12} md={12} lg={10} xl={10} className="mb-2">*/}
          {/*    <FormControl*/}
          {/*      required*/}
          {/*      error={(validation.acceptTerms === false || validation.acceptTerms === "active")}*/}
          {/*      component="fieldset"*/}
          {/*    >*/}
          {/*      <FormGroup>*/}
          {/*        <FormControlLabel*/}
          {/*          id="acceptTerms"*/}
          {/*          name="acceptTerms"*/}
          {/*          value={validation.acceptTerms}*/}
          {/*          control={<Checkbox color="primary" name="acceptTerms" />}*/}
          {/*          labelPlacement="end"*/}
          {/*          label={*/}
          {/*            <>*/}
          {/*              {props.t(`login:Please confirm you have read and `)}*/}
          {/*              <NavLink*/}
          {/*                style={{ color: `${primary_color_2}` }}*/}
          {/*                to={`/algemene_voorwaarden`}*/}
          {/*              >*/}
          {/*                {props.t(`login:Accept our terms`)}*/}
          {/*              </NavLink>*/}
          {/*              {props.t(`login:And`)}*/}
          {/*              <NavLink*/}
          {/*                style={{ color: `${primary_color_2}` }}*/}
          {/*                to={`/privacy_policy`}*/}
          {/*              >*/}
          {/*                {props.t(`login:Conditions`)}*/}
          {/*              </NavLink>*/}
          {/*            </>*/}
          {/*          }*/}
          {/*          onChange={(e) => handleChange(e)}*/}
          {/*          required*/}
          {/*        />*/}
          {/*      </FormGroup>*/}
          {/*      <FormHelperText>*/}
          {/*        {(validation.acceptTerms === false ||*/}
          {/*          validation.acceptTerms === "active") && (*/}
          {/*          <Alert severity="warning">{translated.AcceptTerms}</Alert>*/}
          {/*        )}*/}
          {/*      </FormHelperText>*/}
          {/*    </FormControl>*/}

          {/*  </Grid>*/}
          {/*</Grid>*/}

          <Grid container direction="row" className="mb-2">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <GeneralButton
                type="submit"
                name="submit"
                className="submit_login col-12 col-md-6 col-lg-6"
                endIcon={<HowToRegIcon color="inherit" />}
              >
                {props.t('login:Login')}
              </GeneralButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          {`${company_image}` !== '' && (
            <div style={{ textAlign: 'center' }}>
              <img
                src={`${APP_URL}${site_id}/theme/company_image/${company_image} `}
                alt={company_image}
                className="max-width-fill"
              />
            </div>
          )}
        </Grid>
      </Grid>
    </form>
  );
}

export default React.memo(withTranslation(['message', 'login', 'register'])(LoginFormComponent));
